var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBussleeper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 18,
    viewBox: "0 0 51 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.11.711H3.162c-.724 0-1.378.293-1.85.767a2.61 2.61 0 00-.767 1.855v15.235c0 .724.293 1.38.767 1.854a2.61 2.61 0 001.85.768H47.11a2.615 2.615 0 002.618-2.622V3.333c0-.724-.294-1.38-.768-1.854a2.61 2.61 0 00-1.85-.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C2",
    d: "M42.377 3.032h2.319c.445 0 .851.184 1.146.479.294.294.477.7.477 1.147v12.585a1.62 1.62 0 01-1.623 1.626h-2.319a1.62 1.62 0 01-1.146-.479 1.62 1.62 0 01-.477-1.147V4.658a1.62 1.62 0 011.623-1.626z"
  }))));
}
export default SvgBussleeper;